import {
    ActiveValueType,
    isActiveValueType,
    isPassiveValueType,
    MathAPI,
    PassiveValueType,
    Value,
    ValueType
} from "pokal_api"
import { v4 as uuid } from "uuid"

function randomIntFromInterval(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1) + min)
}

function generatePhqValue() {
    const value: number[] = []
    for (let i = 0; i < 8; ++i) {
        value.push(randomIntFromInterval(0, 3))
    }
    return value
}

function generateSfqValue() {
    const value: number[] = []
    for (let i = 0; i < 5; ++i) {
        value.push(randomIntFromInterval(0, 3))
    }
    return value
}

function generatePassiveDataEntry(
    valueType: PassiveValueType,
    date: Date
): Value[] {
    let entryCount =
        valueType === ValueType.STEPS ? 1 : randomIntFromInterval(1, 4)
    let dateTodayEarly = new Date(new Date(date).setHours(8, 0, 0))
    const results: Value[] = []
    while (entryCount !== 0) {
        switch (valueType) {
            case ValueType.SLEEP_DURATION:
                results.push({
                    id: uuid(),
                    value: randomIntFromInterval(20000, 30000),
                    date: dateTodayEarly
                })
                break
            case ValueType.SLEEP_LATENCY:
                results.push({
                    id: uuid(),
                    value: randomIntFromInterval(0, 5000),
                    date: dateTodayEarly
                })
                break
            case ValueType.SLEEP_HEART_RATE:
                results.push({
                    id: uuid(),
                    value: randomIntFromInterval(40, 70),
                    date: dateTodayEarly
                })
                break
            case ValueType.SLEEP_HEART_RATE_VARIABILITY:
                results.push({
                    id: uuid(),
                    value: randomIntFromInterval(60, 120),
                    date: dateTodayEarly
                })
                break
            case ValueType.STEPS:
                results.push({
                    id: uuid(),
                    value: randomIntFromInterval(1000, 12000),
                    date: dateTodayEarly
                })
                break
        }
        dateTodayEarly = new Date(dateTodayEarly.getTime() + 1000 * 60 * 60)
        entryCount--
    }
    return results
}

function generateActiveDataEntry(
    valueType: ActiveValueType,
    date: Date
): Value[] {
    let entryCount = randomIntFromInterval(1, 4)
    let dateTodayEarly = new Date(new Date(date).setHours(8, 0, 0))
    const results: Value[] = []
    while (entryCount !== 0) {
        switch (valueType) {
            case ValueType.PHQUESTIONNAIRE:
                results.push({
                    value: MathAPI.sum(generatePhqValue()),
                    date: dateTodayEarly,
                    id: uuid()
                })
                break
            case ValueType.SFQUESTIONNAIRE:
                results.push({
                    value: MathAPI.sum(generateSfqValue()),
                    date: dateTodayEarly,
                    id: uuid()
                })
                break
            case ValueType.MOOD:
                results.push({
                    value: randomIntFromInterval(0, 4),
                    date: dateTodayEarly,
                    id: uuid()
                })
        }
        dateTodayEarly = new Date(dateTodayEarly.getTime() + 1000 * 60 * 60)
        entryCount--
    }
    return results
}

function mockPatientData(valueType: ValueType, count: number): Value[] {
    const today = new Date()
    const results: Value[] = []
    for (let i = 0; i < count; ++i) {
        const day = new Date(today.setDate(today.getDate() - 1))
        if (isActiveValueType(valueType)) {
            results.push(
                ...generateActiveDataEntry(valueType as ActiveValueType, day)
            )
        } else if (isPassiveValueType(valueType)) {
            results.push(
                ...generatePassiveDataEntry(valueType as PassiveValueType, day)
            )
        }
    }
    return results
}

export const MOCK_SLEEP_CURRENT_DATA = mockPatientData(
    ValueType.SLEEP_DURATION,
    14
)
export const MOCK_SLEEP_BASELINE_DATA = [
    ...MOCK_SLEEP_CURRENT_DATA,
    ...mockPatientData(ValueType.SLEEP_DURATION, 80)
]

export const MOCK_PHQ_CURRENT_DATA = mockPatientData(
    ValueType.PHQUESTIONNAIRE,
    14
)
export const MOCK_PHQ_BASELINE_DATA = [
    ...MOCK_PHQ_CURRENT_DATA,
    ...mockPatientData(ValueType.PHQUESTIONNAIRE, 40)
]
